import clsx from "clsx"

import { Icon, type IconName } from "../Icon"
import styles from "./ConjoinedIcons.module.css"

export interface ConjoinedIconsProps {
  largeIconName: IconName
  smallIconName: IconName
}

export function ConjoinedIcons(props: ConjoinedIconsProps) {
  const { largeIconName, smallIconName } = props

  return (
    <div className={styles.root}>
      <div className={clsx(styles.circle, styles.large)}>
        <Icon name={largeIconName} size="medium" color="grey11" />
      </div>
      <div className={styles.overlap}>
        <div className={clsx(styles.circle, styles.small)}>
          <Icon name={smallIconName} size="extraSmall" color="purple9" />
        </div>
      </div>
    </div>
  )
}
